import { placesQueryKeys as e } from "./usePlacesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { placesApi as n } from "@maat/api-main";
//#region src/places/useGuestPlaceSearchQuery.ts
var r = (r, i, a = !0) => {
	let o = r.trim();
	return t({
		queryKey: e.autocomplete(o, i?.lat, i?.lng),
		queryFn: () => n.autocomplete({
			input: o,
			lat: i?.lat,
			lng: i?.lng
		}),
		enabled: a && o.length >= 2
	});
};
//#endregion
export { r as useGuestPlaceSearchQuery };
